import type { AuthenticationResult } from "@azure/msal-browser";
import { EventType, PublicClientApplication } from "@azure/msal-browser";

import { getCurrentToken } from "@/utils/auth/tokenFetcher";
import { loginRequest, msalConfig } from "@/utils/auth/config";
import "@/utils/auth/fetch";
import { PCInstance, CLInstance } from "@/SDK";

export const msalInstance = new PublicClientApplication(msalConfig);

export async function initializeMsal() {
  console.log("=> msal initialization..");
  await msalInstance.initialize();

  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    PCInstance.setUser(accounts[0].username);
    CLInstance.init(accounts[0].username);
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback(async (event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;

      PCInstance.setUser(account.username);
      CLInstance.init(account.username);
      msalInstance.setActiveAccount(account);
    }
  });
}

export async function getToken() {
  const authToken = await getCurrentToken(msalInstance);

  console.log("AUTH TOKEN:", authToken);

  return authToken;
}

let loginStarted = false;

export const handleLogin = (loginType = "redirect") => {
  if (loginStarted) return;
  loginStarted = true;

  if (loginType === "popup") {
    msalInstance.loginPopup(loginRequest).catch((e) => {
      loginStarted = false;
      console.error(`loginPopup failed: ${e}`);
    });
  } else if (loginType === "redirect") {
    msalInstance.loginRedirect(loginRequest).catch((e) => {
      loginStarted = false;
      console.error(`loginRedirect failed: ${e}`);
    });
  }
};

export const handleLogout = (logoutType: "redirect" | "popup" = "redirect") => {
  if (logoutType === "popup") {
    msalInstance
      .logoutPopup()
      .then(() => {
        CLInstance.destroy();
        PCInstance.removeUser();
      })
      .catch((e: any) => {
        console.error(`logoutPopup failed: ${e}`);
      });
  } else if (logoutType === "redirect") {
    const logoutRequest = {
      account: msalInstance.getActiveAccount(),
      postLogoutRedirectUri: "/",
    };

    msalInstance
      .logoutRedirect(logoutRequest)
      .then(() => {
        CLInstance.destroy();
        PCInstance.removeUser();
      })
      .catch((e) => {
        console.error(`logoutRedirect failed: ${e}`);
      });
  }
};
